import { render, staticRenderFns } from "./orderReportDetail.vue?vue&type=template&id=64dab20b&scoped=true"
import script from "./orderReportDetail.vue?vue&type=script&lang=js"
export * from "./orderReportDetail.vue?vue&type=script&lang=js"
import style0 from "./orderReportDetail.vue?vue&type=style&index=0&id=64dab20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dab20b",
  null
  
)

export default component.exports